/**
 * The newest published article, kept in one place because two things read it:
 * the Articles grid (first card, "NEW" tag) and the floating card on the home
 * page.
 *
 * `id` is what the dismissal is remembered under — bump it when a newer
 * article takes this slot so the floating card comes back for everyone who
 * dismissed the previous one.
 */
export const LATEST_ARTICLE = {
  id: "agent-is-coding-2026-09",
  title: "The Agent Is Coding. Now What Am I Supposed to Do?",
  desc: "Software development is going agentic. The bottleneck we solved was implementation — the strange one we created is what the developer does while the agent works.",
  link: "https://medium.com/@ben.dev.io/the-agent-is-coding-now-what-am-i-supposed-to-do-aa961418b627",
  date: "2026-09-17",
};

export default LATEST_ARTICLE;
